import { PERFECT_LOOK_OPTIONS } from '../PERFECT_LOOK_OPTIONS';
import { PerfectLookOptionIdType } from '../types';

const DEFAULT_ID: PerfectLookOptionIdType = 'elegant_stylish';
const DEFAULT_TITLE = PERFECT_LOOK_OPTIONS[0].title;

export const getPerfectLookChoiceIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): PerfectLookOptionIdType | null => {
  const id = PERFECT_LOOK_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT_ID;
  }

  return null;
};

export const getPerfectLookChoiceTitleById = (
  id: PerfectLookOptionIdType | null | undefined,
  withDefault = false,
): string | null => {
  const title = PERFECT_LOOK_OPTIONS.find((option) => option.id === id)?.title;

  if (title) {
    return title;
  }

  if (withDefault) {
    return DEFAULT_TITLE;
  }

  return null;
};
